import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchSocialMediaAPI,
  createSocialMediaAPI,
  updateSocialMediaAPI,
  deleteSocialMediaAPI,
} from "./socialMediaAPI";
import { showModal } from "../statusModal/statusModal";

const initialState = {
  list: [],
  fetchStatus: "idle",
  error: null,
};

export const fetchSocialMedia = createAsyncThunk(
  "socialMedia/fetchAll",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchSocialMediaAPI();
      dispatch(
        showModal({ message: "تم جلب روابط التواصل", status: "success" })
      );
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "فشل في جلب روابط التواصل", status: "error" })
      );
      return rejectWithValue(error.response?.data?.message || "خطأ غير متوقع");
    }
  }
);

export const createSocialMedia = createAsyncThunk(
  "socialMedia/create",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const data = await createSocialMediaAPI(payload);
      dispatch(
        showModal({ message: "تمت إضافة رابط جديد", status: "success" })
      );
      return data;
    } catch (error) {
      dispatch(showModal({ message: "فشل في الإضافة", status: "error" }));
      return rejectWithValue(error.response?.data?.message || "خطأ غير متوقع");
    }
  }
);

export const updateSocialMedia = createAsyncThunk(
  "socialMedia/update",
  async ({ name, data }, { dispatch, rejectWithValue }) => {
    try {
      const updated = await updateSocialMediaAPI({ name, ...data });
      dispatch(showModal({ message: "تم تحديث الرابط", status: "success" }));
      return updated;
    } catch (error) {
      dispatch(showModal({ message: "فشل في التحديث", status: "error" }));
      return rejectWithValue(error.response?.data?.message || "خطأ غير متوقع");
    }
  }
);

export const deleteSocialMedia = createAsyncThunk(
  "socialMedia/delete",
  async (name, { dispatch, rejectWithValue }) => {
    try {
      await deleteSocialMediaAPI(name);
      dispatch(showModal({ message: "تم حذف الرابط", status: "success" }));
      return name;
    } catch (error) {
      dispatch(showModal({ message: "فشل في الحذف", status: "error" }));
      return rejectWithValue(error.response?.data?.message || "خطأ غير متوقع");
    }
  }
);

const socialMediaSlice = createSlice({
  name: "socialMedia",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSocialMedia.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchSocialMedia.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchSocialMedia.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload;
      })

      .addCase(createSocialMedia.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(createSocialMedia.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list.unshift(action.payload);
      })
      .addCase(createSocialMedia.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload;
      })

      .addCase(updateSocialMedia.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(updateSocialMedia.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        const index = state.list.findIndex(
          (item) => item.name === action.payload.name
        );
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })
      .addCase(updateSocialMedia.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload;
      })

      .addCase(deleteSocialMedia.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(deleteSocialMedia.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list = state.list.filter((item) => item.name !== action.payload);
      })
      .addCase(deleteSocialMedia.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload;
      });
  },
});

export default socialMediaSlice.reducer;
